export const AppSettingsVar = { portal_prefix:'/', debug: false};
